// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';


// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule, msalInstance } from './app/app.module';

async function bootstrapApp() {
  try {
    
    //await msalInstance.initialize();
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  } catch (error) {
    console.error('MSAL initialization failed:', error);
  }
}

bootstrapApp();
